/* tslint:disable */
export default {
  ADD_ATTACHMENT: 'Add attachment',
  ADD_CONTENT: 'Add content',
  ADD_ENGAGEMENT_BUTTON_TEXT: 'Add another engagement',
  ADD_EPIC_BUTTON: 'Add epic',
  ADD_NEW_PAGE_TITLE_LABEL: 'Page title',
  ADD_NEW_PAGE_TITLE_LENGTH_VALIDATION_ERROR:
    'Invalid title. Must be between 1 and 60 characters long.',
  ADD_NEW_PAGE_HEADER: 'Add new page',
  ADD_NEW_PAGE_BUTTON_TEXT: 'Add new page',
  ADD_NEW_PAGE_SUBMIT_BUTTON_TEXT: 'Add',
  ADD_PEER_REVIEWERS: 'Add peer reviewers',
  ADD_PEER_REVIEWERS_DESC:
    'To ensure your content raises the bar for the customer we require a minimum of one review by a domain expert. Use the tools below to add a qualified reviewer(s) based on the technologies and AWS services used in your content. Content checklist must be completed before sending a review request.',
  ADD_REVIEWER: 'Add reviewer',
  ADD_TASK_BUTTON_TEXT: 'Add story',
  ADD_TASK_WARNING_TEXT: 'Please turn off code view to add your story.',
  ADMIN_COLLECTION_COL_AUDIENCE: 'Who can view',
  ADMIN_COLLECTION_COL_COLLECTION_ID: 'Collection ID',
  ADMIN_COLLECTION_COL_LAST_MODIFIED: 'Last modified',
  ADMIN_COLLECTION_COL_OFFICIAL_OFFERING_ID: 'Official offering',
  ADMIN_COLLECTION_COL_STATE: 'State',
  ADMIN_COLLECTION_COL_UNOFFICIAL_OFFERING_ID: 'Unofficial offering',
  ADMIN_CONSOLE: 'Administration',
  ADMIN_DASHBOARD: 'Admin dashboard',
  ADMIN_DASHBOARD_COLLECTION_HEADER: 'Collections',
  ADMIN_UNLOCK_WORKFLOW_SUCCESS_MESSAGE: 'Successfully unlocked draft.',
  ADMIN_UNLOCK_WORKFLOW_ERROR_MESSAGE: 'Error while unlocking drafts.',
  ADMIN_UNLOCK_WORKFLOW_MODAL_HEADER: 'Unlock content',
  ADMIN_UNLOCK_WORKFLOW_SUBMIT_BUTTON_TEXT: 'Unlock',
  ADMIN_UNLOCK_WORKFLOW_BUTTON_TEXT: 'Unlock content',
  ALL_CONTENTS: 'All content',
  ALREADY_ACCEPTED_REVIEW_TEXT: 'You have already accepted the review request.',
  ALREADY_APPROVED_CONTENT_TEXT: 'You have already approved the content.',
  ALREADY_DISAPPROVED_CONTENT_TEXT: 'You have already disapproved the content.',
  AMAZON_LOGIN_DESCRIPTION1: 'Sign in with your registered account',
  AMAZON_LOGIN_DESCRIPTION2:
    'Sign in to the APG Library using your registered account, which you created with your corporate email.',
  AMAZON_LOGIN_DESCRIPTION3: 'New user? Please create your APG Library account.',
  AMAZON_LOGIN_DESCRIPTION4: 'Click here to create your account',
  AMAZON_LOGIN_DESCRIPTION6:
    "Creating and whitelisting your APG Library account may take up to one business day. When the process is complete, you'll receive an email confirming your access to APG Library.",
  AMAZON_LOGIN_HEADER: 'Customers and APN Partners',
  APGL_USER_PROFILE: 'APGL user profile',
  APG_WEBSITE_URL: 'https://aws.amazon.com/prescriptive-guidance',
  APP_DESCRIPTION:
    'You have the solutions AWS customers need - author, peer review, and publish now to accelerate their journey to the AWS Cloud.',
  APP_NAME: 'APG Library',
  APP_NAME_FULL: 'AWS Prescriptive Guidance Library',
  APP_NAME_BREAD_CRUMB: 'APG',
  APP_NAME_SIDE_NAV: 'APG Library',
  APPROVAL_PENDING_CONTENTS: 'Content to review',
  APPROVE_BUTTON_TEXT: 'Approve',
  APPROVALS: 'Approval(s)',
  APPROVER_ACTIONS: 'Reviewer actions',
  ARCHITECTURE_LABEL: 'Architecture',
  ASK_QUESTION_HEADER: 'Ask a question',
  ASK_QUESTION_TITLE_LABEL: 'Question title',
  ASK_QUESTION_TITLE_PLACEHOLDER: 'Enter question title here',
  ASK_QUESTION_DESCRIPTION_LABEL: 'Question',
  ASK_QUESTION_DESCRIPTION_PLACEHOLDER: 'Ask your question here',
  ASK_QUESTION_EMAIL: 'Email',
  ASK_QUESTION_EMAIL_PLACEHOLDER: 'Enter email',
  ASK_QUESTION_EMAIL_INVALID: 'Please enter a valid email address',
  ASSIGN_TECH_WRITER: 'Assign Tech Writer',
  ASSUMPTION_LABEL: 'Prerequisites and limitations',
  ATTACHMENTS_HEADER: 'Attachments',
  ATTACHMENTS_INFECTED_INFO:
    "Attention! Some of your uploaded files have been identified as trojans, viruses, malware, or other malicious file types. We've quarantined them for safety reasons and won't propagate them with a publication. Please submit an issue if you think your files have been identified incorrectly.",
  ATTACHMENTS_INSTRUCTION_GUIDE_STRATEGY:
    'Add supplemental information such as diagram source files (.pptx) or checklists (.xlsx). Do not attach scripts and code samples; use the Code tab instead.',
  ATTACHMENTS_INSTRUCTION_PATTERN:
    'Allowed attachments: Diagram source files (.pptx), checklists (.xlsx), supplemental Word files (.docx).',
  ATTACHMENTS_NO_ATTACHMENTS_INFO: 'No attachments available.',
  ATTACHMENTS_NO_ATTACHMENTS_TAB_VIEW_INFO: 'There are currently no attachments.',
  ATTACHMENTS_TAB_LABEL: 'Attachments',
  ATTACHMENTS_WARNING_TEXT:
    'Do not attach scripts, templates, compiled code, or code projects. Use the Code tab to add those in a code repository.',
  ATTACHMENT_DOWNLOAD_INFECTED:
    'This attachment has been flagged as containing a virus and cannot be downloaded.',
  ATTACHMENT_DOWNLOAD_NOT_SCANNED:
    'This attachment is still being scanned for viruses and cannot be downloaded yet. Please try again later.',
  AUTHOR_GUIDANCE: 'My guidance',
  AUTHOR_CONTENTS_HEADER: "Content I've authored",
  AUTHOR_REQUESTS: 'My content suggestions',
  AUTHOR_REVIEWS: 'My reviews',
  AUTHORED_CONTENT_TABLE_HEADER: 'Content I created',
  AUTHORS_METADATA_LABEL: 'Author(s)',
  BACK_TO_CONTENTS_HEADER: 'Content',
  BAR_RAISER_CONTROL_FEEDBACK_TOO_LONG_ERROR:
    'Overall content feedback exceeds maximum (400 characters).',
  BAR_RAISER_CONTROL_FEEDBACK_MISSING_ERROR: 'Overall content feedback should be provided.',
  BAR_RAISER_CONTROL_MISSING_DRAFT_FEEDBACK_ERROR:
    'If rejecting content, content feedback should be provided and will be shared with author.',
  BAR_RAISER_CONTROL_MISSING_PUBLISHED_FEEDBACK_ERROR:
    'If recommend unpublishing content, content feedback should be provided.',
  BAR_RAISER_CONTROL_MISSING_RESPONSE_ERROR:
    'Responses to all the questions should be provided for the quality score to be calculated and for the bar raiser to be able to “Publish”.',
  BAR_RAISER_CONTROL_MISSING_PUBLISHED_RESPONSE_ERROR:
    'Responses to all the questions should be provided.',
  BAR_RAISER_CONTROL_COMMENT_TOO_LONG_ERROR:
    'One or more of questionnaire comment exceeds maximum (300 characters).',
  BAR_RAISER_DASHBOARD: 'Bar raiser dashboard',
  BAR_RAISER_LEADERBOARD_DESCRIPTION: "Based on current quarter's review activity",
  BAR_RAISER_QUESTIONNAIRE: 'Bar Raiser Quality Questionnaire',
  BUGS_PAGE_HEADER: 'Submit issue',
  CANCEL_BUTTON_TEXT: 'Cancel',
  CANCEL_NEW_CONTENT_TEXT: 'Cancel new content',
  CANCEL_NEW_CONTENT_CONFIRMATION: 'Yes, cancel this content',
  CANCEL_CONTENT_INSTRUCTION:
    'If you cancel, you will lose all work associated with the new content.\nAre you sure you want to cancel?',
  CANCEL_CREATE_CONFIRMATION: 'Yes, cancel create',
  CANCEL_CREATE_INSTRUCTION:
    'If you cancel, you will lose all information you entered in this form.\nAre you sure you want to cancel?',
  CANCEL_CREATE_TEXT: 'Cancel creating APGL user profile',
  CANCEL_UPDATE_PROFILE_CONFIRMATION: 'Yes, cancel editing',
  CANCEL_UPDATE_PROFILE_INSTRUCTION:
    'If you cancel, you will lose all your changes and your APGL user profile will be reverted.\nAre you sure you want to cancel?',
  CANCEL_UPDATE_PROFILE_TEXT: 'Cancel editing APGL user profile',
  CATEGORIES_PLACEHOLDER: 'Select categories',
  CATEGORY_LABEL: 'Category',
  CLEAR_ALL_FILTERS: 'Clear all filters',
  CLEAR_BUTTON_TEXT: 'Clear form',
  CLEAR_FILTERS_REFRESH_TOOLTIP: 'Clear filters when table is refreshed',
  CLEAR_PREFERENCES_TEXT: 'Clear preferences',
  CLEAR_PREFERENCES_CONFIRM_TEXT:
    'Are you sure you want the table preference settings to be removed?',
  CLONE_CONTENT_BUTTON_TEXT: 'Clone content',
  CLOSE_BUTTON_TEXT: 'Close',
  CARDS_LABEL: 'Cards',
  CODE_BLOCK_VALIDATION_ERROR:
    'Your content has more than 50 lines of embedded code. Please migrate to a code repository.',
  CODE_REPO_ADD_BUTTON_TEXT: 'Add repository',
  CODE_REPO_AUDIENCE_ERROR: 'Incorrect code repo type for target audience.',
  CODE_REPO_DUPLICATE_ERROR: 'This code repository already exists in the list.',
  CODE_REPO_URL_EMPTY_ERROR: 'Code repository URL cannot be empty.',
  CODE_REPO_HEADER_TEXT: 'Code repository',
  CODE_REPO_APPSEC_TICKET_ERROR: 'AppSec ticket is required',
  CODE_REPO_APPSEC_STATUS_ERROR: 'AppSec status is required',
  CODE_REPO_OPEN_SOURCE_TICKET_ERROR: 'Open source process ticket is required',
  CODE_REPO_OPEN_SOURCE_STATUS_ERROR: 'Open source process status is required',
  CODE_REPO_TITLE_EMPTY_TEXT: 'Repo title is required.',
  CODE_REPO_PLACEHOLDER: 'https://code.amazon.com/packages/myRepo',
  CODE_REPO_URL_INVALID_GITHUB_REPO_ERROR:
    'Repositories in personal Github accounts are not supported.',
  CODE_REPO_URL_INVALID_DOMAIN_ERROR: 'Unsupported domain name.',
  CODE_REPO_URL_HTTPS_ERROR: 'Only HTTPS URLs are supported.',
  CODE_REPO_LINK_NO_SPACE_ERROR: 'There should not be space inside URL.',
  CODE_REPO_TITLE_DUPLICATE_ERROR: 'This link title already exists in the list.',
  CODE_REPO_TITLE_PLACEHOLDER: 'My repo',
  CODE_REPO_INTERNAL_NOTICE:
    'External sharing of content marked as Internal is strictly restricted to customers/partners under SOW only.',
  CODE_REPO_MODAL_INFO_PART_1:
    'Accepted code repos are code.amazon.com, code.aws.dev, gitlab.aws.dev or an official AWS repo (such as aws-samples) on github.com (not your own private repo). AWS Prescriptive Guidance follows the',
  CODE_REPO_MODAL_INFO_LINK_TEXT_1: 'AppSec Security Guidance for AWS Content',
  CODE_REPO_MODAL_INFO_PART_2: 'process for all repos.',
  CODE_REPO_MODAL_INFO_PART_3:
    'Accepted security review URLs must be in an approved domain and start with https://. Approved domains include sim.amazon.com, issues.amazon.com, t.corp.amazon.com, and taskei.amazon.dev. Open source review URL also allows github.com. Trailing forward slash is not allowed and special characters, such as & and ?, are not allowed.',
  CODE_REPO_SECURITY_REVIEW_INFO_LINK_1: 'Click here',
  CODE_REPO_SECURITY_REVIEW_INFO_TEXT_1:
    'to create a ticket for the security review process and link it below. This ticket will be assigned to you and includes required steps and directions. You should log all of your results to this ticket. When you are finished,',
  CODE_REPO_SECURITY_REVIEW_INFO_LINK_2: 'click here',
  CODE_REPO_SECURITY_REVIEW_INFO_TEXT_2:
    'to find a Security Guardian who will review your steps and results.',
  CODE_REPO_OS_REVIEW_INFO_LINK_1: 'Click here',
  CODE_REPO_OS_REVIEW_INFO_TEXT_1:
    'to create a ticket for the open source process and copy the ticket link below. When it is completed, update the status.',
  CODE_REPO_INVALID_URL:
    'Invalid URL. Only valid HTTPS URLs to repositories under certain domains are supported.',
  CODE_REVIEW_VALIDATION_ERROR: 'Attached code repo has unresolved security review tickets.',
  CODE_VALIDATION_ERROR_INTRO_TEXT:
    'Please review the following issues before submitting for peer review:',
  CODE_TAB_LABEL: 'Code',
  COLLECTION_DROPDOWN_HEADER: 'Collections',
  COLLECTION_EPIC_CSV_HEADER_EPIC_DESC: 'Epic description',
  COLLECTION_EPIC_CSV_HEADER_EPIC_ORDER: 'Epic order',
  COLLECTION_EPIC_CSV_HEADER_EPIC_TITLE: 'Epic title',
  COLLECTION_EPIC_CSV_HEADER_STORY_DESC: 'Story description',
  COLLECTION_EPIC_CSV_HEADER_STORY_ORDER: 'Story order',
  COLLECTION_EPIC_CSV_HEADER_STORY_TITLE: 'Story title',
  COLLECTION_VIEWER_ATTACHMENT_AND_REPO_COL: 'Attachments and repositories',
  COLLECTION_VIEWER_ATTACHMENTS: 'Attachments',
  COLLECTION_VIEWER_DESCRIPTION: 'Collection description',
  COLLECTION_VIEWER_EPICS: 'Epics',
  COLLECTION_VIEWER_GUIDANCE_COL: 'Guidance',
  COLLECTION_VIEWER_REPOSITORY: 'Repository',
  COLLECTION_VIEWER_STORY_DESC_COL: 'Description',
  COLLECTION_VIEWER_STORY_TITLE_COL: 'User story title',
  COMMENT: 'Comments',
  COMMENT_FOR_PUBLISHER_FETCH_FAILED: 'Failed to fetch comments',
  COMMENT_PUBLISHED: 'Comment published',
  COMMENTS_PENDING_CONTENTS: 'Comments to publish',
  COMMENTS_VERSION_SELECTION_PLACEHOLDER: 'Select a version',
  COMMENTS_EMPTY_ERROR: 'Comment cannot be empty',
  COMMENTS_LENGTH_LIMIT_ERROR: 'Comment must be 4000 characters or less.',
  COMMENTS_LENGTH_LIMIT: 4000,
  COMMENTS_RESOLVED_BUTTON_TEXT: 'Mark as resolved',
  COMMENTS_RESOLVED_DIALOG_HEADER: 'Resolve comment',
  COMMENTS_RESOLVED_DIALOG_BUTTON_TEXT: 'Do you want to resolve this comment?',
  COMMENTS_RESOLVED_DIALOG_SUBMIT_BUTTON_TEXT: 'Resolve',
  COMMENTS_UNRESOLVE_BUTTON_TEXT: 'Mark as unresolved',
  COMMENTS_UNRESOLVE_DIALOG_HEADER: 'Unresolve comment',
  COMMENTS_UNRESOLVE_DIALOG_BUTTON_TEXT: 'Do you want to unresolve this comment?',
  COMMENTS_UNRESOLVE_DIALOG_SUBMIT_BUTTON_TEXT: 'Unresolve',
  COMMENTS_EDIT_BUTTON_TEXT: 'Edit',
  COMMENTS_EDIT_DIALOG_HEADER: 'Edit comment',
  COMMENTS_EDIT_DIALOG_SUBMIT_BUTTON_TEXT: 'Save',
  COMMENTS_DELETE_BUTTON_TEXT: 'Delete',
  COMMENTS_DELETE_DIALOG_HEADER: 'Delete comment',
  COMMENTS_DELETE_DIALOG_BUTTON_TEXT: 'Do you want to delete this comment?',
  COMMENTS_DELETE_DIALOG_SUBMIT_BUTTON_TEXT: 'Delete',
  COMMENTS_FORM_PLACEHOLDER: 'Leave your notes or feedback',
  COMMENTS_FORM_BUTTON_TEXT: 'Post',
  COMMENTS_ACTIVE_THREAD_TAB: 'Active thread',
  COMMENTS_HISTORY_TAB: 'History',
  CONTACT_US: 'Contact us',
  REPLY: 'Reply',
  REPLIES: 'Replies',
  COMPLETED_CONTENT_ID_PLACEHOLDER: 'Enter completed content ID',
  CONFIGURATION_SECTION_HEADER: 'Configuration',
  CONFIRM_BUTTON_TEXT: 'Confirm',
  CONFIRM_CHANGES_BUTTON_TEXT: 'Confirm changes',
  CREATE_PROFILE_BUTTON_TEXT: 'Create profile',
  CONFIRM_CREATE_CONFIRMATION: 'Yes, confirm create',
  CONFIRM_CREATE_INSTRUCTION: 'Are you sure you want to confirm creating your APGL user profile?',
  CONFIRM_CREATE_TEXT: 'Confirm creating APGL user profile',
  CONFIRM_PUBLISH_BUTTON_TEXT: 'Confirm publish',
  CONFIRM_REVOKE_AND_UNPUBLISH_MODAL_TEXT:
    'We found a previous content version to be public on APG site. Unpublishing this content will first revoke that version from APG and remove the currently published version of the content.\nIt will still be available to the author content list.\n\nAre you sure you want to unpublish this content?',
  CONFIRM_UNPUBLISH_BUTTON_TEXT: 'Confirm unpublish',
  CONFIRM_UPDATE_CONFIRMATION: 'Yes, confirm update',
  CONFIRM_UNPUBLISH_MODAL_TEXT:
    'Unpublishing a content will remove the currently published version of the content.\nIt will still be available to the author content list.\n\nAre you sure you want to unpublish this content?',
  CONTENT_ALREADY_UNPUBLISHED_ERROR: 'Content has already been unpublished',
  CONTENT_AUDIENCE_CANNOT_EDIT_DRAFT:
    'Cannot edit intended audience if a content has not been submitted for review.',
  CONTENT_AUDIENCE_CANNOT_EDIT_PUBLISHED:
    'Cannot edit intended audience if a content has been published.',
  CONTENT_AUDIENCE_CANNOT_PUBLISH_MESSAGE:
    'Intended Audience for a content is set to AWS internal or AWS and APG Partners',
  CONTENT_AUDIENCE_LABEL: 'Intended audience',
  CONTENT_AUDIENCE_MODAL_HEADER: 'Intended audience',
  CONTENT_AUDIENCE_PLACEHOLDER: 'Select the intended audience',
  CONTENT_AUDIENCE_UPGRADE_NOTICE:
    'Only upgrading intended audience is allowed. A publication must be in draft state to change the intended audience.',
  GUIDANCE_BACKLOG: 'Guidance backlog',
  CONTENT_CARDS_AUTHOR: 'Author',
  CONTENT_CARDS_LAST_UPDATED_LABEL: 'Last updated',
  CONTENT_CARDS_LOADING_CONTENT_LABEL: 'Loading content',
  NO_CONTENT_LABEL: 'No content',
  CONTENT_CARDS_NO_MATCHES_LABEL:
    'We are sorry. We could not find any results for your search term.',
  CONTENT_CHECKLIST_HEADER: 'Content checklist',
  CONTENT_CHECKLIST_INCOMPLETE_ALERT:
    'Please complete the checklist before assigning a peer reviewer or submitting for review.',
  CONTENT_CONVERSION_ALREADY_CONVERTED_ERROR:
    'Content has already been converted. Save or discard your changes before attempting to change content type.',
  CONTENT_CONVERSION_ERROR: 'Content conversion failed due to error',
  CONTENT_CONVERSION_LEFT_HEADER: 'Migrate from',
  CONTENT_CONVERSION_RIGHT_HEADER: 'Migrate to',
  CONTENT_COMMENT_PLACEHOLDER: 'Enter comment...',
  CONTENT_CREATION_DUPLICATE_CONTENT_MESSAGE:
    "To prevent duplicate content please review the articles below to ensure you're not creating duplicate content.",
  CONTENT_CREATION_DUPLICATE_SEARCH_MESSAGE: 'Searching for duplicate content...',
  CONTENT_CREATION_NO_DUPLICATE_CONTENTS: 'No duplicate content found',
  CONTENT_DESCRIPTION_LABEL: 'Overview',
  CONTENT_DESCRIPTION_DESCRIPTION:
    'Describe the proposed content in one sentence. This appears on the home page card.',
  CONTENT_DESCRIPTION_PLACEHOLDER:
    'Provide a short summary of your content, to be displayed in search results. Avoid repeating the title, but include relevant keywords.',
  CONTENT_DETAILS_HEADER: 'Details',
  CONTENT_ENGAGEMENT_DUPLICATE_SALESFORCE_URL: 'Duplicate Salesforce project/opportunity found',
  CONTENT_ENGAGEMENT_INVALID_SALESFORCE_URL: 'Salesforce project url is invalid.',
  CONTENT_ENGAGEMENT_INVALID_SALESFORCE_PROJECT:
    'Salesforce project is invalid. It should contain atmost 18 characters with at least 1 alpha and 1 numeric characters. Lightning url should end with /view',
  CONTENT_ENGAGEMENT_INVALID_SALESFORCE_OPPORTUNITY:
    'Salesforce opportunity is invalid. It should contain atmost 18 characters with at least 1 alpha and 1 numeric characters. Lightning url should end with /view',
  CONTENT_ENGAGEMENT_INVALID_SALESFORCE_LIGHTNING_SUFFIX:
    'Salesforce lightning url should end with \/view.',
  CONTENT_ENGAGEMENT_MISSING_SALESFORCE_PROJECT: 'Please enter Salesforce project',
  CONTENT_ENGAGEMENT_INPUT_NOTES_LABEL: 'Notes about engagement',
  CONTENT_ENGAGEMENT_INPUT_NOTES_PLACEHOLDER: 'Notes about engagement',
  CONTENT_ENGAGEMENT_INPUT_SALESFORCE_LABEL: 'Salesforce project or sub-project*',
  CONTENT_ENGAGEMENT_INPUT_SALESFORCE_PLACEHOLDER: 'XXXXXXXXXXXXXXXXXX/view',
  CONTENT_ENGAGEMENT_MODAL_HEADER:
    'Thanks for sharing. To help us learn more and evaluate our library of solutions, please provide the Salesforce project or sub project of the engagement',
  CONTENT_ENGAGEMENT_MODAL_MESSAGE:
    'To help us evaluate our library, please provide the Salesforce URLs that this content either has been used in (project or subproject), or would unblock (opportunity)*',
  CONTENT_ENGAGEMENT_MODAL_TITLE: 'Customer influences',
  CONTENT_ENGAGEMENT_QUESTION: 'Used this content in an engagement?',
  CONTENT_ENGAGEMENT_RADIO_LABEL: 'Type*',
  CONTENT_ENGAGEMENT_TYPE_PROJECT_LABEL: 'Project',
  CONTENT_ENGAGEMENT_TYPE_OPPORTUNITY_LABEL: 'Opportunity',
  CONTENT_HEADER: 'Content',
  CONTENT_NAME_LABEL: 'Title',
  CONTENT_NAME_PLACEHOLDER: 'Provide a short but descriptive title for your content',
  CONTENT_PAGE_INVALID_TEXT:
    'Content page invalid. Please refresh the page to load the latest content. If the issue persists, please submit a ticket or contact APGL admin.',
  CONTENT_REQUEST_DETAILS: 'Content suggestion detail',
  CONTENT_REQUEST_SUMMARY: 'Content request summary',
  CONTENT_REQUEST_CREATION_HEADER: 'Create suggestion',
  CONTENT_REQUEST_CREATION_HEADER_DESC:
    'Propose a new strategy, guide, or pattern that will help expand the APG content catalog.',
  CONTENT_REQUEST_CREATION_TITLE: 'Title*',
  CONTENT_REQUEST_CREATION_TITLE_DESC: 'Add a short, descriptive title for your content',
  CONTENT_REQUEST_CREATION_CODE_INTEGRATION_TEXT: 'This suggestion requires code',
  CONTENT_REQUEST_CREATION_DESCRIPTION_HEADER: 'Description*',
  CONTENT_REQUEST_CREATION_DESCRIPTION_DESC:
    'Provide a short summary of what the content should cover',
  CONTENT_REQUEST_CREATION_DESCRIPTION_PLACEHOLDER: 'Type description',
  CONTENT_REQUEST_CREATION_CONFIGURATION_HEADER: 'Configuration',
  CONTENT_REQUEST_CREATION_CONTENT_TYPE_LABEL: 'Content type*',
  CONTENT_REQUEST_CREATION_MAIN_TECHNOLOGY_LABEL: 'Main technology',
  CONTENT_REQUEST_CREATION_MAIN_TECHNOLOGY_DESCRIPTION:
    'The primary use case that applies to your suggested content',
  CONTENT_REQUEST_CREATION_ADDITIONAL_TECHNOLOGY_LABEL: 'Additional technologies',
  CONTENT_REQUEST_CREATION_ADDITIONAL_TECHNOLOGY_DESCRIPTION: 'Other relevant use cases',
  CONTENT_REQUEST_CREATION_WORKLOAD_DESCRIPTION:
    'Does your suggested content involve Microsoft, Oracle, IBM, SAP, or open-source technologies?',
  CONTENT_REQUEST_CREATION_AWS_SERVICES_DESCRIPTION: 'AWS services that your suggestion highlights',
  CONTENT_REQUEST_CREATION_CREATE_SUGGESTION_BUTTON_TEXT: 'Create suggestion',
  CONTENT_REQUEST_CREATION_INVALID_MESSAGE: 'Please make sure all input are valid.',
  CONTENT_REQUEST_CREATION_DUPLICATE_SEARCH_MESSAGE: 'Searching for duplicate content...',
  CONTENT_REQUEST_CREATION_DUPLICATE_CONTENT_MESSAGE:
    "To prevent duplicate content please review the articles below to ensure you're not creating duplicate content.",
  CONTENT_REQUEST_CREATION_NO_DUPLICATE_CONTENT: 'No duplicate content found.',
  CONTENT_REQUESTS_APPROVE_LABEL: 'Approve',
  CONTENT_REQUESTS_APPROVE_TEXT:
    'Are you sure that you want to approve this suggestion so that it can be assigned?',
  CONTENT_REQUESTS_DASHBOARD: 'Content suggestions',
  CONTENT_REQUESTS_DELETION_LABEL: 'Delete suggestion',
  CONTENT_REQUESTS_DELETION_TEXT: 'Are you sure that you want to delete this suggestion?',
  CONTENT_REQUESTS_DESCRIPTION_PLACEHOLDER:
    'Provide a short summary of what the content should cover.',
  CONTENT_REQUESTS_EDIT: 'Edit content suggestions',
  CONTENT_REQUESTS_HEADER: 'Content suggestions',
  CONTENT_REQUESTS_REJECT_LABEL: 'Reject',
  CONTENT_REQUESTS_REJECT_TEXT: 'Are you sure that you want to reject this suggestion?',
  CONTENT_REQUEST_ADD_SUGGESTION: 'Add suggestion',
  CONTENT_REQUEST_ASSIGN_SELF_BUTTON_TEXT: 'Assign to self',
  CONTENT_REQUEST_ASSIGN_OTHER_BUTTON_TEXT: 'Assign to author',
  CONTENT_REQUEST_NO_SUGGESTION: 'No suggestion',
  CONTENT_REQUEST_NO_SUGGESTION_TO_DISPLAY: 'No content suggestions to display.',
  CONTENT_REQUEST_NO_MATCH: 'No matches found',
  CONTENT_REQUEST_FILTER_LABEL: 'Find suggestion',
  CONTENT_REQUEST_OWNER_TITLE: 'Content already owned',
  CONTENT_REQUEST_REASSIGN_TITLE: 'Author already assigned',
  CONTENT_REQUEST_SEARCH_SUGGESTION_LABEL: 'Find suggestion',
  CONTENT_REQUEST_LOADING_SUGGESTION_LABEL: 'Loading suggestion',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_HEADER: 'Content assigned to me',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_ACCEPT_HEADER: 'Accept content for creation',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_ACCEPT_BODY: 'Determine when you want to author the content.',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_ACCEPT_UPDATE_HEADER: 'Content review assignment',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_ACCEPT_UPDATE_BODY:
    'Do you wish to review this content to ensure that it is up to date and provides accurate guidance?',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_CREATE_LATER: 'Create later',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_CREATE_NOW: 'Create now',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_CREATE_DRAFT: 'Create draft',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_DECLINE_HEADER: 'Decline content assignment',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_DECLINE_BODY: 'Forward content asssignment',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_DECLINE_BODY_DESC:
    'Decline and send assignment to another author',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_REFRESH_NOTICE:
    'Content request asssignment has been updated. Please refresh the table to reflect the change.',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_UPDATE_LATER: 'Review later',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_UPDATE_NOW: 'Review now',
  CONTENT_REQUEST_ASSIGNMENT_TABLE_UPDATE_PUBLICATION: 'Update publication',
  CONTENT_REQUEST_ORDER_BY_CREATED_DATE_LABEL: 'Date created',
  CONTENT_REQUEST_ORDER_BY_ASSIGNMENT_DATE_LABEL: 'Date assigned',
  CONTENT_REQUEST_ORDER_BY_TOTAL_LIKES_LABEL: 'Total likes',

  CONTENT_REQUESTS_MANAGEMENT: 'Content suggestion management',
  CONTENT_REQUESTS_TABLE_HEADER: 'Content I suggested',
  CONTENT_RETRACT_ERROR_MESSAGE:
    'Failed to retract content from review. Please refresh your screen and try again. If the problem persists, submit an issue from the navigation bar.',
  CONTENT_RETRACT_NOT_PENDING_MESSAGE: 'Content is not pending review and cannot be retracted.',
  CONTENT_RETRACT_REVIEW_MESSAGE:
    'Are you sure you want to retract this content from peer review: ',
  CONTENT_RETRACT_SUCCESS_MESSAGE: 'Content is successfully retracted from review.',
  CONTENT_REVOKE_AND_UNPUBLISH_SUCCESS_MESSAGE:
    'Content has been unpublished successfully with a previous version revoked from APG public site',
  CONTENT_SECTION_EDIT_HEADER: 'Edit section',
  CONTENT_SECTION_TITLE_PLACEHOLDER: 'Enter section title',
  CONTENT_SUGGESTIONS_LABEL: 'Content suggestions',
  CONTENT_SUMMARY: 'Content summary',
  CONTENT_TAB_LABEL: 'Content',
  CONTENT_TO_REVIEW_TABLE_HEADER: 'Content assigned to me for peer review',
  CONTENT_TYPE_LABEL: 'Content type',
  CONTENT_TYPE_PLACEHOLDER: 'Select the content type',
  CONTENT_PAGE_NAVIGATION_HEADER: 'Pages',
  CONTENT_PROBLEM_SOLVED_LABEL: 'Problem solved',
  CONTENT_PROBLEM_SOLVED_DESCRIPTION: 'Describe the real-world use case for the proposed content.',
  CONTENT_PROPOSAL_LABEL: 'Proposal',
  CONTENT_PROPOSAL_DESCRIPTION:
    'Describe the proposed content in more detail so that we can make sure your proposed topic is unique, relevant, and well suited for APG Library. ',
  CONTENT_UNPUBLISH_SUCCESS_MESSAGE: 'Content has been unpublished successfully',
  CONTENT_UPDATES_TABLE_HEADER: 'Content to update',
  CONTENT_UPDATES_TABLE_HEADER_DESCRIPTION:
    'Please review to ensure that content is up to date and provides accurate guidance',
  CONTENT_UPDATES_ACTION_ACKNOWLEDGE_TEXT:
    'This content is up to date and provides accurate guidance.',
  CONTENT_UPDATES_ACTION_COAUTHOR_BUTTON: 'Confirm',
  CONTENT_UPDATES_ACTION_COAUTHOR_BUTTON_TEXT: 'Get help making updates',
  CONTENT_UPDATES_ACTION_COAUTHOR_HEADER: 'Get help making updates',
  CONTENT_UPDATES_ACTION_COAUTHOR_LABEL: 'Co-author',
  CONTENT_UPDATES_ACTION_COAUTHOR_CONTROL_MESSAGE:
    'Add a co-author if you need help updating the content',
  CONTENT_UPDATES_ACTION_COAUTHOR_MESSAGE:
    'Ask a specific person to help make updates, making them a co-author',
  CONTENT_UPDATES_ACTION_COAUTHOR_TEXT:
    'Send this to the content backlog for updates from other AWS employees, making them a co-author.',
  CONTENT_UPDATES_ACTION_UPDATE_BUTTON: 'Update',
  CONTENT_UPDATES_ACTION_UPDATE_BUTTON_TEXT: 'Make updates',
  CONTENT_UPDATES_ACTION_UPDATE_HEADER: 'Update content',
  CONTENT_UPDATES_ACTION_UPDATE_TEXT: 'Accept and update outdated content?',
  CONTENT_UPDATES_ACTION_NOUPDATE_BUTTON: 'Confirm',
  CONTENT_UPDATES_ACTION_NOUPDATE_BUTTON_TEXT: 'Information is up to date',
  CONTENT_UPDATES_ACTION_NOUPDATE_HEADER: 'Content is up to date',
  CONTENT_UPDATES_ACTION_NOUPDATE_LABEL: 'Notes',
  CONTENT_UPDATES_ACTION_ADD_COAUTHOR: 'Add co-author',
  CONTENT_VISIBILITY_CURRENT_VERSION_LABEL: 'Current:',
  CONTENT_VISIBILITY_LABEL: 'Visibility',
  CONTENT_VISIBILITY_PREVIOUS_VERSION_LABEL: 'Previous versions',
  CREATE_APGL_USER_PROFILE_ERROR:
    'Failed to create user profile. Please refresh your screen and try again. If the problem persists, submit an issue from the navigation bar.',
  CREATE_BUTTON_TEXT: 'Create content',
  CREATE_COLLECTION: 'Create collection',
  CREATE_CONTENT: 'Create new content',
  CREATE_CONTENT_DESCRIPTION:
    'Tell us about the content you want to create. Your proposed content should be unique and not duplicate any existing AWS content, such as service documentation or blogs. Approved proposals will move to the draft stage for authoring.',
  CREATE_CONTENT_ERROR_MESSAGE:
    'Failed to create content. Please refresh your screen and try again. If the problem persists, submit an issue from the navigation bar.',
  CREATE_CONTENT_FORM_HEADER: 'Create new content',
  CREATE_GUIDE: 'Create Guide',
  CREATE_GUIDE_DESCRIPTION_TEXT: 'Multi-page content for concepts, best practices, and strategies',
  CREATE_GUIDE_DROPDOWN_TEXT: 'Managerial guide',
  CREATE_IN_AMAZON_ACCOUNT_INFO_DESCRIPTION:
    "If you don't have an existing Amazon account, you will need to create one to sign in to APG Library.",
  CREATE_IN_AMAZON_ACCOUNT_INFO_HEADER: '*Create an Amazon account*',
  CREATE_PATTERN: 'Create Pattern',
  CREATE_PATTERN_DESCRIPTION_TEXT: 'Single-page, instructional content for a specific task',
  CREATE_PATTERN_DROPDOWN_TEXT: 'Practitioner pattern',
  CREATE_SUGGESTION_DESCRIPTION_TEXT: 'leave an idea for someone else to write about.',
  CREATE_SUGGESTION_DROPDOWN_TEXT: 'Suggestion',
  CREATE_CONTENT_WIZARD_AUDIENCE_DESCRIPTION: 'Choose who can access this content.',
  CREATE_CONTENT_WIZARD_AUDIENCE_LABEL: 'Intended audience',
  CREATE_CONTENT_WIZARD_CANCEL_BUTTON: 'Cancel',
  CREATE_CONTENT_WIZARD_NEXT_BUTTON: 'Next',
  CREATE_CONTENT_WIZARD_PREVIOUS_BUTTON: 'Previous',
  CREATE_CONTENT_WIZARD_STEP1_TITLE: 'Content type and audience',
  CREATE_CONTENT_WIZARD_STEP1_ERROR: 'Please select both content type and intended audience',
  CREATE_CONTENT_WIZARD_STEP2_TITLE: 'Content metadata',
  CREATE_CONTENT_WIZARD_STEP2_TECH_DOMAINS_HEADER: 'Technology domains',
  CREATE_CONTENT_WIZARD_STEP2_MAIN_TECH_LABEL: 'Main technology',
  CREATE_CONTENT_WIZARD_STEP2_MAIN_TECH_DESCRIPTION:
    'Choose the primary technical domain that applies to your content',
  CREATE_CONTENT_WIZARD_STEP2_MAIN_TECH_PLACEHOLDER: 'Choose main technology',
  CREATE_CONTENT_WIZARD_STEP2_ADDITIONAL_TECH_LABEL: 'Additional technologies',
  CREATE_CONTENT_WIZARD_STEP2_ADDITIONAL_TECH_DESCRIPTION:
    'Choose other relevant technology domains that apply to your content.',
  CREATE_CONTENT_WIZARD_STEP2_ADDITIONAL_TECH_PLACEHOLDER: 'Choose additional technologies',
  CREATE_CONTENT_WIZARD_STEP2_OTHER_METADATA_HEADER: 'Other metadata',
  CREATE_CONTENT_WIZARD_STEP2_AWS_SERVICES_LABEL: 'AWS services',
  CREATE_CONTENT_WIZARD_STEP2_AWS_SERVICES_DESCRIPTION:
    'Choose the AWS services that your content highlights',
  CREATE_CONTENT_WIZARD_STEP2_AWS_SERVICES_PLACEHOLDER: 'Choose AWS services',
  CREATE_CONTENT_WIZARD_STEP2_WORKLOAD_LABEL: 'Workload',
  CREATE_CONTENT_WIZARD_STEP2_WORKLOAD_DESCRIPTION:
    'Choose whether your content involves non-AWS technologies, such as IBM or open source.',
  CREATE_CONTENT_WIZARD_STEP2_WORKLOAD_PLACEHOLDER: 'Choose workload',
  CREATE_CONTENT_WIZARD_STEP3_TITLE: 'Content details',
  CREATE_CONTENT_WIZARD_STEP3_LONG_TITLE_DESCRIPTION:
    'Enter a long title. This title appears as the page title.',
  CREATE_CONTENT_WIZARD_STEP3_SHORT_TITLE_DESCRIPTION:
    'Enter a short title. This title appears on the home page card and in search experiences.',
  CREATE_CONTENT_WIZARD_STEP3_OVERVIEW_DESCRIPTION:
    'Describe the proposed content in one sentence. This overview appears on the home page card listing.',
  CREATE_CONTENT_WIZARD_STEP3_PROPOSAL_DESCRIPTION:
    "Describe your proposed content in more detail. This is used only by an AI agent and won't be shown to readers.",
  CREATE_CONTENT_WIZARD_STEP3_PROBLEM_SOLVED_DESCRIPTION:
    "Describe the real-world use case for the proposed content. This is used only by an AI agent and won't be shown to readers.",
  CREATE_CONTENT_WIZARD_STEP4_TITLE: 'Duplicate check',
  CREATE_CONTENT_WIZARD_SUBMIT_BUTTON: 'Create draft',
  CREATE_CONTENT_WIZARD_CONTENT_TYPE_LABEL: 'Content type',
  CREATE_CONTENT_WIZARD_CONTENT_TYPE_DESCRIPTION: 'Select the type of content you want to create.',
  CREATE_CONTENT_WIZARD_CONTENT_TYPE_PATTERN_LABEL: 'Pattern',
  CREATE_CONTENT_WIZARD_CONTENT_TYPE_PATTERN_DESCRIPTION:
    'Instructional content for a specific task',
  CREATE_CONTENT_WIZARD_CONTENT_TYPE_GUIDE_LABEL: 'Guide',
  CREATE_CONTENT_WIZARD_CONTENT_TYPE_GUIDE_DESCRIPTION:
    'Content for concepts, best practices, frameworks, and strategies',
  CREATED_BY: 'Created by',
  DASHBOARD: 'Dashboard',
  DASHBOARD_NEW: 'New dashboard',
  DAYS_IN_A_WEEK: 7,
  DECIMAL: 10,
  DEFAULT_TAB_TITLE: 'APG Library',
  DELETE_ATTACHMENT_ALT: 'Delete attachment',
  DELETE_ATTACHMENT_ERROR: 'Attachment deletion failed',
  DELETE_ATTACHMENT_SUCCESS: 'Attachment deleted',
  DELETE_BUTTON_TEXT: 'Delete',
  DELETE_CONTENT_BUTTON_TEXT: 'Delete',
  DELETE_COLLECTION_EPIC_BUTTON_TEXT: 'Yes',
  DELETE_CONTENT_HEADER_TEXT: 'Delete',
  DELETE_COLLECTION_EPIC_HEADER_TEXT: 'Delete Epic ',
  DELETE_COLLECTION_STORY_HEADER_TEXT: 'Delete User Story',
  DELETE_CONTENT_INFO_MESSAGE: 'Cannot delete if content is in review or published state.',
  DELETE_CONTENT_MODAL_TEXT: 'Do you want to delete this content?',
  DELETE_COLLECTION_EPIC_MODAL_TEXT: 'Are you sure you want to delete this epic?',
  DELETE_COLLECTION_STORY_MODAL_TEXT: 'Are you sure you want to delete this user story?',
  DELETE_CONTENT_SUGGESTION_MODAL_TEXT: 'Do you want to delete this content suggestion?',
  DELETE_CONTENTS_MODAL_DESCRIPTION: 'Do you want to delete these contents?',
  DELETE_ICON_URI:
    'M17.114,3.923h-4.589V2.427c0-0.252-0.207-0.459-0.46-0.459H7.935c-0.252,0-0.459,0.207-0.459,0.459v1.496h-4.59c-0.252,0-0.459,0.205-0.459,0.459c0,0.252,0.207,0.459,0.459,0.459h1.51v12.732c0,0.252,0.207,0.459,0.459,0.459h10.29c0.254,0,0.459-0.207,0.459-0.459V4.841h1.511c0.252,0,0.459-0.207,0.459-0.459C17.573,4.127,17.366,3.923,17.114,3.923M8.394,2.886h3.214v0.918H8.394V2.886z M14.686,17.114H5.314V4.841h9.372V17.114z M12.525,7.306v7.344c0,0.252-0.207,0.459-0.46,0.459s-0.458-0.207-0.458-0.459V7.306c0-0.254,0.205-0.459,0.458-0.459S12.525,7.051,12.525,7.306M8.394,7.306v7.344c0,0.252-0.207,0.459-0.459,0.459s-0.459-0.207-0.459-0.459V7.306c0-0.254,0.207-0.459,0.459-0.459S8.394,7.051,8.394,7.306',
  DESCRIPTION_LABEL: 'Description',
  DESCRIPTION_PLACEHOLDER: 'Enter content description.',
  DETAILS_TAB_LABEL: 'Details',
  DISABLE_APPROVE_WHEN_EDITING_MESSAGE:
    'Approval is not allowed while the author is modifying content.',
  DISABLE_APPROVE_WHEN_OUTDATED_MESSAGE:
    'In order to approve, please refresh page to view latest content.',
  DISAPPROVALS: 'Disapproval(s)',
  DOWNLOAD_AS_CSV: 'Download as CSV',
  DUPLICATE_EPIC_TITLE: 'Epic already exists',
  DUPLICATE_REQUEST_ID_NOT_FOUND: 'Duplicate request ID not found',
  DUPLICATE_REQUEST_ID_PLACEHOLDER: 'Enter duplicate request ID',
  DUPLICATE_REQUEST_SAME_AS_REQUESTID: 'Duplicate request ID cannot be same as current request ID',
  DUPLICATE_TASK_TITLE: 'Story already exists',
  EDIT_ATTRIBUTE_INPUT_LABEL: 'Enter value',
  EDIT_ATTRIBUTE_LABEL: 'Select attribute to edit',
  EDIT_CO_AUTHORS: 'Edit co-authors',
  EDIT_EPIC_FORM_HEADER: 'Edit epic',
  EDIT_GUIDE: 'Edit Guide',
  EDIT_HEADER: 'Edit',
  EDIT_COLLECTION_TITLE_HEADER: 'Edit Title',
  EDIT_COLLECTION_DESCR_HEADER: 'Edit Description',
  DONE_EDIT_HEADER: 'Done',
  // tslint:disable-next-line:max-line-length
  EDIT_ICON_URI:
    'M619 1664l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832H256v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z',
  EDIT_PATTERN: 'Edit Pattern',
  EDIT_PEER_REVIEWERS: 'Edit peer reviewers',
  EDIT_STRATEGY: 'Edit Strategy',
  EDIT_TASK_BUTTON_TEXT: 'Save',
  EDIT_TASK_FORM_HEADER: 'Edit story',
  EDIT_TASK_WARNING_TEXT: 'Please turn off code view to save your changes.',
  EDIT_USER_PERMISSION_BUTTON_TEXT: 'Edit permissions',
  EDIT_USER_PERMISSION_INPUT_INVALID:
    'Current user permissions and input one are different. Please click search on user to receive the correct user roles',
  EDIT_USER_PERMISSION_UNAUTHORIZED_USER_TYPE:
    'Non-AWS user is not allowed to be granted system roles',
  EMPTY_TASK_LIST: 'No stories',
  EPIC_DESCRIPTION_LABEL: 'Epic description',
  EPIC_DESCRIPTION_PLACEHOLDER:
    'Epics are high-level constructs that guide the user through the use of the content. When they’re collapsed, these high-level steps should reflect a logical flow of deploying, migrating, or executing the content. That is, epics should show the user what needs to be done at a high level. As guidance, the EPIC stories should be explicit enough to ensure the user knows how to do the step/action. As well the EPICs as a whole should answer the question start to finish of how to actually invoke / launch / deploy what was stated in the content title.',
  EPIC_REMOVE_CONFIRM_WITH_TASKS:
    'This operation will remove all stories from this epic and cannot be undone. Please confirm the delete operation.',
  EPIC_REMOVE_CONFIRM_WITHOUT_TASKS:
    'This operation cannot be undone. Please confirm the delete operation.',
  EPICS_TAB_LABEL: 'Epics',
  EPIC_TITLE_LABEL: 'Epic title *',
  EPIC_TITLE_PLACEHOLDER: 'Epic title *',
  EPIC_TITLE_REQUIRED: 'Epic title required',
  EPIC_TITLE_TOO_LONG: 'Maximum epic title length is 300 characters',
  EPICS_LABEL: 'Epics',
  ERROR_CREATE_CONTENT:
    'Failed to create content request. Please try again. If the problem persists, submit an issue from the navigation bar.',
  ERROR_IN_SAVING: 'Cannot save',
  ERROR_TO_OPEN_CONTENT_DESCRIPTION:
    'This content has been removed or unpublished by the administrator',
  ERROR_TO_OPEN_CONTENT_HEADER: 'Cannot open content',
  ERROR_TO_OPEN_CONTENT_PREVIEW_DESCRIPTION:
    "This version of the content has been deleted, or you don't have permissions to access it.",
  ERROR_TO_OPEN_CONTENT_PREVIEW_HEADER: 'Cannot open content preview',
  EVALUATE_PUBLICATION_QUALITY: 'Evaluate publication quality',
  EXPAND_ALL: 'Expand all',
  EXPERTISE_EMPTY_ERROR: 'Expertise cannot be empty',
  FAILED_TO_FETCH_WORKFLOW_DATA: 'Failed to fetch workflow data',
  FAILED_TO_LOAD_DASHBOARD_DATA: 'Unable to load dashboard data',
  FAILED_TO_LOAD_PATTERN_MATRIX: 'Unable to load content matrix',
  FAILED_TO_LOAD_REQUESTS: 'Unable to load content requests',
  FAILED_TO_LOAD_USER_LIST: 'Failed to load user list',
  FAILED_TO_LOAD_USERS_ROLE: "Failed to load user's role",
  FAILED_TO_PUBLISH_A_COMMENT: 'Failed to publish comment',
  FAQ: 'FAQ',
  FEATURE_REQUEST_PAGE_HEADER: 'Submit feature request',
  FEEDBACK: 'Feedback',
  FILTERS: 'Refine results',
  FILTER_CONTENT_LABEL: 'Filter content',
  FILTER_INPUT_MIN_LENGTH: 3,
  FINALIZE_BUTTON_TEXT: 'Finalize',
  FINALIZE_GUIDE: 'Finalize Guide',
  FINALIZE_MODAL_DESCRIPTION: 'Do you want to finalize this content?',
  FINALIZE_MODAL_HEADER: 'Finalize',
  FINALIZE_PATTERN: 'Finalize Pattern',
  FINALIZE_PENDDING_CONTENTS: 'Content to finalize',
  FINALIZE_STRATEGY: 'Finalize Strategy',
  FIND_CONTENT_PLACEHOLDER: 'Find content',
  GENERIC_ERROR_MESSAGE: 'Correct errors before submitting content',
  GUIDE_INSTRUCTION_TEXT:
    'Guidance for planning and implementing strategies, with focus on best practices and tools, for architects, managers, and technical leads.',
  GUIDE_LABEL: 'Guides',
  HISTORY_TAB_LABEL: 'History',
  IMAGE_UPLOAD_HEIGHT_WIDTH_TOOLTIP:
    'Specify % or px (e.g., 100% or 100px). Use auto to keep the original height and width.',
  INLINE_COMMENT_OPEN_COMMENTS: 'Open comments',
  INLINE_COMMENT_RESOLVED_COMMENTS: 'Resolved comments',
  INTENDED_AUDIENCE_SECTION_HEADER: 'Intended audience',
  INTENDED_AUDIENCE_SECTION_DESCRIPTION: 'After review process, content will be visible to:',
  IS_CODE_INCLUDED_DESCRIPTION: 'Check this box if your content includes scripts or code samples.',
  IS_CODE_INCLUDED_LABEL: 'Script/code included',
  IS_TEST_DESCRIPTION:
    "Check this box if you're creating this content for testing or demo purposes. It will be excluded from analysis and reporting.",
  IS_TEST_LABEL: 'Test/demo content',
  ISVS_LABEL: 'Independent software vendor',
  ISVS_PLACEHOLDER: 'Select independent software vendor',
  KEEP_EDITING_TEXT: 'No, keep editing',
  KEEP_WRITING_TEXT: 'No, keep writing',
  KNOWN_ISSUES: 'Known issues/limitations',
  LABEL_LAST_PUBLISHED: 'Last published on',
  LABEL_UNPUBLISHED: 'Unpublished on',
  LABEL_VERSION: 'Version',
  LAST_MODIFIED: 'Last modified',
  LIFECYCLE_LABEL: 'Lifecycle',
  LIFECYCLE_PLACEHOLDER: 'Select lifecycle',
  LIST_LABEL: 'List',
  LOADING_AUTO_SUGGESTIONS: 'Loading...',
  LOADING_CONTENT: 'Loading content ...',
  LOGIN_HEADER: 'Welcome to APG Library. To continue, please log in.',
  LOGO_NAME: 'AWS',
  LOGOUT: 'Logout',
  LOGOUT_DESCRIPTION:
    'New user? After initial login, your access rights to the application will be reviewed and approval will be communicated to the registered email.',
  LOGOUT_HEADER: 'Please log in again',
  LOGOUT_SUCCESSFUL: 'You have logged out successfully',
  LONG_TITLE_DESCRIPTION: 'Enter a long title. This title appears as the page title.',
  LONG_TITLE_LABEL: 'Long title',
  LONG_TITLE_PLACEHOLDER_TEXT: 'Provide a short but descriptive title for your content.',
  MAINTENANCE_INFO_APG_UPGRADE_BODY_MESSAGE:
    'Pattern Library is being sunset. We’re in the process of launching AWS Prescriptive Guidance (APG) Library in its place. APG Library is the new platform for authoring, publishing, and discovering prescriptive guidance in the form of strategies, guides, and patterns. You can continue to view and update your existing patterns at this URL shortly. You can also author new patterns, and create strategies and guides. The enhanced Library will get a UI makeover and improved functionality for authors and technical reviewers.',
  MAINTENANCE_INFO_APG_UPGRADE_HEADER_MESSAGE: 'Under construction',
  MAINTENANCE_INFO_MESSAGE_1: 'Currently unavailable due to maintenance',
  MAINTENANCE_INFO_MESSAGE_2: 'Please check back later',
  MARK_REQUESTS_AS_COMPLETE: 'Mark requests as complete',
  MARK_REQUESTS_AS_IN_PROGRESS: 'Mark requests as in progress',
  MAX_SERVICES_EXCEEDED: 'Maximum 5 AWS services',
  MIDWAY_LOGIN_BUTTON_TEXT: 'Midway',
  MIDWAY_LOGIN_DESCRIPTION: 'Amazon employees: click here to log in with Midway',
  MIDWAY_LOGIN_HEADER: 'Amazon employees',
  MISCELLANEOUS_LABEL: 'Miscellaneous',
  MY_COLLECTION_ADDITIONAL_AUTHORS: 'Additional authors',
  MY_COLLECTION_AUDIENCE_LABEL_INTERNAL: 'All AWS employees',
  MY_COLLECTION_AUDIENCE_LABEL_ONLY_OWNER: 'Only owners',
  MY_COLLECTION_COL_AUDIENCE: 'Who can view collection',
  MY_COLLECTION_COL_DRAFT_TEXT: 'Draft',
  MY_COLLECTION_COL_LAST_MODIFIED: 'Last modified date',
  MY_COLLECTION_COL_OWNERS: 'Owners',
  MY_COLLECTION_COL_PUBLISHED_TEXT: 'Published',
  MY_COLLECTION_COL_STATUS: 'Status',
  MY_COLLECTION_COL_TITLE: 'Title',
  MY_COLLECTION_DEFAULT_PAGE_SIZE: 10,
  MY_COLLECTION_FILTER_LABEL: 'Filter collections by property or value',
  MY_COLLECTION_LABLE: 'My collections',
  MY_COLLECTION_LOCKED_HEADER: 'This collection is locked',
  MY_COLLECTION_LOCKED_MESSAGE_SUFFFIX: ' is currently making edits.',
  MY_COLLECTION_LOCKED_MESSAGE: 'Only one author at a time can make changes to collections.',
  MY_COLLECTION_NO_COLLECTIONS_DISPLAY_LABEL: 'No collections to display.',
  MY_COLLECTION_NO_COLLECTIONS_LABEL: 'No collections',
  MY_QUEUE_LABEL: 'My queue',
  MUST_BE_LESS_THAN_2000_INPUT_ERROR: 'Must be less than 2000 characters.',
  MISSING_REQUIRED_FIELD: 'Missing required field.',
  NO_COMMENTS_FOR_CONTENT: 'This content does not have any comments yet',
  NO_CONTENTS_CREATED_YET: 'No content has been created yet',
  NO_EPICS:
    'Epics are high-level constructs that guide the user through the use of the pattern. To create an epic, use the "Add Epic" button.',
  NO_PENDING_COMMENTS_FOUND_FOR_PUBLISHER: 'No comments are pending publication',
  NO_PENDING_CONTENT_FOUND_FOR_PUBLISHER: 'No content is pending publication',
  NO_PENDING_REQUESTS: 'There are no pending requests',
  NO_OPEN_FEEDBACK: 'This publication does not have any open feedback',
  NO_OPEN_OR_CLOSED_FEEDBACK: 'This publication does not have any open or closed feedback',
  NO_REQUEST_FOUND_FOR_AUTHOR: 'There are no submitted requests',
  NO_RESULT_FOUND: 'No results found',
  NOT_PUBLISHED: 'Not published',
  NOTE_DISPLAY_LENGTH_LIMIT: 100,
  NOTE_LENGTH_LIMIT_ERROR: 'Note must be 4000 characters or less.',
  NOTE_LENGTH_LIMIT: 4000,
  NOTICE_OF_PUBLICATION_HEADER: 'External publishing by selection only',
  OK_BUTTON_TEXT: 'OK',
  ONE_SECOND_IN_MILLI: 1000,
  OPEN_ADDITIONAL_ITEMS_INSTRUCTION: 'I confirm:',
  OPEN_ADDITIONAL_ITEMS_TEXT: 'Open additional items',
  OPEN_CONTENT_ITEMS_TEXT: 'Open content items',
  OPEN_CONTENT_ITEMS_INSTRUCTION: 'I confirm that this content:',
  OPEN_LEGAL_ITEMS_INSTRUCTION: 'Remove the following from all APG content:',
  OPEN_LEGAL_ITEMS_TEXT: 'Open legal items',
  PAGE_NOT_FOUND: '404 - Page not found.',
  PAGE_NOT_FOUND_MESSAGE: 'The page you are trying to access does not exist. Please check the URL.',
  PAGE_TITLE_PLACEHOLDER: 'Enter a page title between 1 and 60 characters long...',
  PATTERN_ACCREDITATION_LABEL: 'Pattern accreditation',
  PATTERN_ACCREDITATION_PLACEHOLDER: 'Select pattern accreditation',
  PATTERN_CATEGORIES: 'Pattern categories',
  PATTERN_COMMENT_PLACEHOLDER: 'Enter comment...',
  PATTERN_INSTRUCTION_TEXT:
    'Steps, architectures, tools and code for implementing common migration, optimization and modernization scenarios, for builders and for other hands-on users.',
  PATTERN_LABEL: 'Patterns',
  PATTERN_MATRIX: 'Pattern matrix',
  PATTERN_MATRIX_HEADER: 'Pattern matrix',
  PATTERN_NAME_LABEL: 'Pattern name',
  PATTERN_NAME_PLACEHOLDER: 'Descriptive name for the pattern...',
  PATTERN_PROVENANCE_LABEL: 'Pattern provenance',
  PATTERN_PROVENANCE_PLACEHOLDER: 'Select pattern provenance',
  PATTERN_REQUEST_SUMMARY: 'Pattern request summary',
  PATTERN_REQUESTS_MANAGEMENT: 'Pattern request management',
  PATTERN_SUMMARY: 'Pattern summary',
  PATTERN_TITLE_LABEL: 'Pattern title *',
  PATTERN_TITLE_PLACEHOLDER: 'Provide a short but descriptive title for your pattern',
  PATTERN_TYPE_LABEL: 'Pattern type',
  PATTERN_TYPE_PLACEHOLDER: 'Select pattern type',
  PEER_REVIEWERS_INSTRUCTION:
    'Add a peer reviewer to your content before submitting to peer review.',
  PEER_REVIEWERS: 'Peer reviewers',
  PEER_REVIEWERS_MISSING:
    'Mininum one reviewer is required to submit for review. For partner created content, at least one AWS peer reviewer required.',
  PENDING_COMMENT_PHRASE:
    'This comment is currently under review. It will become publicly available when it has been approved by an APG Library administrator.',
  PERMISSIONS_TAB_LABEL: 'Permissions',
  PERMISSIONS: 'Permissions',
  POLLING_DELAY: 30000,
  POPULAR_CATEGORIES: 'Content categories',
  POST_COMMENT: 'Post comment',
  POST_COMMENT_DESCRIPTION:
    'Comments are reviewed by an APG Library administrator before they become publicly available',
  POST_COMMENT_LABEL: 'Post a new comment',
  PREFERENCES: 'Preferences',
  PREVIEW_BUTTON_TEXT: 'Preview',
  PUBLIC_RELEASE_PRIORITY_TOOLTIP: 'Bar raiser assigned publication priority for tech writers',
  PUBLICATION_HISTORY: 'Published history',
  PUBLICATION_HISTORY_HEADER_DESCRIPTION: 'Select a version to view the list of associated events.',
  PUBLICATION_HISTORY_COMPARE_BUTTON_TEXT: 'Compare versions',
  PUBLICATION_HISTORY_EMPTY_MESSAGE: 'No history available.',
  PUBLICATION_TITLE_EMPTY_ERROR: 'Title cannot be empty',
  PUBLICATION_URL_EMPTY_ERROR: 'URL cannot be empty',
  PUBLICATION_URL_HTTPS_ERROR: 'We only support HTTPS URL.',
  PUBLICATION_URL_INVALID_ERROR: 'Invalid URL.',
  PUBLICATION_URL_NO_SPACE_ERROR: 'There should be no space inside URL.',
  PUBLISH_A_COMMENT_MODAL_DESCRIPTION: 'Do you really want to publish these comments?',
  PUBLISH_A_COMMENT_MODAL_HEADER: 'Publish comments',
  PUBLISH_ACTION_MODAL_HEADER: 'Publish content',
  PUBLISH_BUTTON_TEXT: 'Publish',
  PUBLISH_COMMENTS_PLACEHOLDER: 'Enter comments here...',
  PUBLISH_MODAL_CONTENT:
    'Published pages will be visible to all authenticated users.\nAre you sure you want to publish this content?',
  PUBLISH_PENDING_CONTENTS: 'Content to publish',

  PUBLISH_REJECT_MODAL_CONTENT: 'Are you sure you want to reject the publication of this content?',
  PUBLISHED_CONTENTS: 'Published',
  PUBLISHER_ACTIONS: 'Publisher actions',
  PUBLISHER_COMMENTS_HEADER: 'Comments to publish',
  PUBLISHER_CONTENTS_HEADER: 'Content to publish',
  PUBLISHER_CONTENT_UPDATES_HEADER: 'Contents to update',
  PUBLISHER_PUBLISH_APGL_HEADER: 'Publish to interal APGL',
  PUBLISHER_PUBLISH_APGL_SUBMIT_BUTTON_TEXT: 'Internally publish',
  PUBLISHER_ERROR: 'Publication failed.',
  REFERENCES_LABEL: 'References and help',
  REFINE_SEARCH: 'Refine search',
  REFINE_SEARCH_DESCRIPTION: 'Select a catagory and activate filters on the current results.',
  REJECT_PUBLICATION_BUTTON_TEXT: 'Reject publication',
  RELATED_CONTENTS: 'Related content',
  REMOVE_PERMISSION_ERROR: 'Failed to remove user permission',
  REMOVE_PERMISSION_MODAL_HEADER: 'Remove permission',
  REMOVE_PERMISSION_SUCCESSFULLY: 'Removed permission successfully',
  REORDER_CONTENT_PAGES_HEADER: 'Re-order Pages',
  REORDER_CONTENT_PAGES_BUTTON_TEXT: 'Re-order pages',
  REORDER_CONTENT_PAGES_SUBMIT_BUTTON_TEXT: 'Apply',
  REORDER_CONTENT_PAGES_INFO_TEXT: 'Select a page and use the up/down buttons to re-order',
  REORDER_CONTENT_PAGES_MOVE_UP_BUTTON_TEXT: 'Move up',
  REORDER_CONTENT_PAGES_MOVE_DOWN_BUTTON_TEXT: 'Move down',
  REORDER_CONTENT_PAGES_MOVE_INTO_BUTTON_TEXT: 'Move into next',
  REQUEST_BUTTON_TEXT: 'Suggest new content',
  REQUEST_CONTENT: 'Suggest content',
  REQUEST_PAGE_HEADER: 'Suggest new content',
  REQUIRED: 'Required field',
  RESET_ALL: 'Reset all',
  RESOURCE_NAME_CREATION_GUIDE_LONG: 'Guide for authors',
  RESOURCE_NAME_CREATION_GUIDE_SHORT: 'Guide for authors',
  RESOURCE_NAME_EDITING_GUIDE_LONG: 'Guide for reviewers',
  RESOURCE_NAME_EDITING_GUIDE_SHORT: 'Guide for reviewers',
  RESOURCES: 'Resources',
  RESTORE_PREVIOUS_LOCAL_SAVED_VERSION:
    "You previously edited this content but didn't save your changes. Do you want to restore the copy you were working on?",
  RESTORE_PREVIOUS_VERSION_HEADER: 'Restore previous changes?',
  RESULTS_LABEL: 'Results',
  REVIEW_ACTION_MODAL_HEADER: 'Review content',
  REVIEW_APPROVE_MODAL_COMMENT_HEADER: 'To approve, provide your approval message below',
  REVIEW_APPROVE_MODAL_CONTENT: 'Are you sure you want to approve this content?',
  REVIEW_APPROVE_MODAL_HEADER: 'Approve content',
  REVIEW_COMMENTS_PLACEHOLDER: 'Enter comments here...',
  REVIEW_SEND_BACK_MODAL_COMMENT_HEADER: 'To send back to author, provide your concerns below',
  REVIEW_SEND_BACK_MODAL_CONTENT: 'Are you sure you want to send this content back to the author?',
  REVIEW_SEND_BACK_MODAL_HEADER: 'Send back to author',
  REVIEWED_CONTENTS: 'Reviewed',
  REVIEWER_CONTENTS_HEADER: 'Content to review',
  REVIEWER_ERROR: 'Review failed.',
  REVIEWER_TAB_LABEL: 'Reviewers',
  REVIEW_REQUEST_ACCEPT_MODAL_TEXT: 'Do you really want to accept this review request?',
  REVIEW_REQUEST_ACCEPTED_TEXT:
    'You have accepted the review request. Please refresh the table to view the updated reviewer queue.',
  REVIEW_REQUEST_ALREADY_DECLINED_TEXT:
    'You have already been removed from the peer reviewer list. Please refresh the table to view the updated reviewer queue.',
  REVIEW_REQUEST_DECLINE_MODAL_TEXT: 'Do you really want to decline this review request?',
  REVIEW_REQUEST_DECLIEND_TEXT:
    'You have declined the review request. Please refresh the table to view the updated reviewer queue.',
  RTYPE_LABEL: 'R type',
  RTYPE_PLACEHOLDER: 'Select the migration strategy',
  SAVE_BUTTON_TEXT: 'Save',
  SAVE_CONTROL_HEADER: 'Actions',
  SLA_PUBLISHER: 14,
  NEAR_SLA_IN_DAYS: 3,
  EDIT_COLLECTION_COL_LABEL_DELETE: 'Delete',
  EDIT_COLLECTION_COL_LABEL_EMAIL: 'Email',
  EDIT_COLLECTION_COL_LABEL_NAME: 'Name',
  EDIT_COLLECTION_PERMISSION_LABEL_ADD_OWNER: 'Add owner',
  EDIT_COLLECTION_STATUS_FOOTER: 'Status: ',
  SAVE_DRAFT_TEXT: 'Save draft',
  SAVE_USER_PERMISSION_BUTTON_TEXT: 'Save permissions',
  SAVED_SUCCESSFULLY: 'Saved successfully',
  SAVING: 'Saving',
  SEARCH_BAR_EMPTY: 'No suggestions found.',
  SEARCH_CATEGORIES_HERE: 'Filter categories...',
  SEARCH_CONTENT_BUTTON_TEXT: 'Search',
  SEARCH_CONTENT_HEADER: 'Search APG Library',
  SEARCH_CONTENT_PLACEHOLDER: 'Search strategies, guides, and patterns',
  SEARCH_CONTENTS: 'Search content',
  SEARCH_FILTERS_DELETE_SUCCESS_TEXT: 'Filter view deleted successfully',
  SEARCH_FILTERS_RENAME_SUCCESS_TEXT: 'Filter view renamed successfully',
  SEARCH_FILTERS_SAVE_SUCCESS_TEXT: 'Filter view saved successfully',
  SEARCH_FILTERS_SET_DEFAULT_SUCCESS_TEXT: 'Default filter view set successfully',
  SEARCH_LABEL: 'Search',
  SEARCH_RESULTS: 'Search results',
  SEARCH_RESULTS_EMPTY_MESSAGE: 'We are sorry. We could not find any results for your search term.',
  SELECT_CONTENT_ATTRIBUTE_TO_UPDATE_PLACEHOLDER: 'Select attribute to update',
  SELECT_PREDECESSOR: 'Select predecessor',
  SELECT_TECH_WRITER: 'Select a Tech Writer',
  SEND_BACK_BUTTON_TEXT: 'Send back to author',
  SEND_FOR_REVIEW_BUTTON_TEXT: 'Submit for review',
  SEND_FOR_REVIEW_ERROR: 'Failed to send content for review',
  SEND_FOR_REVIEW_MODAL_DESCRIPTION_EDIT_MODE:
    'You will not be able to remove peer reviewers without administrator assistance once sent for review. Are you sure you wish to send it for review?',
  SEND_FOR_REVIEW_MODAL_HEADER: 'Send for review',
  SEND_FOR_REVIEW_STARTED: 'Sending content for review',
  SEND_FOR_REVIEW_SUCCESS: 'Content has been sent for review',
  SET_PREFERENCES_TEXT: 'Set preferences',
  SHARE_ENGAGEMENT: 'Share engagement',
  SHARE_GUIDANCE: 'Can I share guidance?',
  SHARED_CONTENTS_HEADERS: 'Content I co-authored',
  SHORT_TITLE_DESCRIPTION:
    'Enter a short title. This title appears on the home page card and in search experiences.',
  SHORT_TITLE_LABEL: 'Short title',
  SHORT_TITLE_NODE_DESCRIPTION:
    'Enter a short title. This title appears in navigation and the table of contents.',
  SHORT_TITLE_NODE_PLACEHOLDER_TEXT:
    'Provide a shorter title for navigation and table of contents.',
  SHORT_TITLE_PLACEHOLDER_TEXT:
    'Provide a shorter title for cards on the home page and search results.',
  SHOULD_REVOKE_PUBLIC_CONTENT_ERROR:
    'Public content should be first revoked from APG before you attempt to unpublish it',
  SIGN_IN_AMAZON_ACCOUNT_INFO_DESCRIPTION:
    'Sign in to the APG Library using your Amazon account. This includes credentials for your Amazon account or any account that uses the "Login and Pay with Amazon" widget (such as Woot or Zappos).',
  SIGN_IN_AMAZON_ACCOUNT_INFO_HEADER: '*Sign in with an Amazon account*',
  SKIP_DRAFT_REVIEW_MODAL_HEADER: 'Send back to author (and skip next draft review)',
  SKIP_DRAFT_REVIEW_MODAL_TEXT:
    'Sending content back to authors will allow them to skip the review for the next draft to immediately publish content changes.',
  SKIP_DRAFT_REVIEW_BUTTON_TEXT: 'Send back to author',
  SKIP_DRAFT_REVIEW_SUCCESS_MESSAGE: 'Content sent back to author(s)',
  SKIP_DRAFT_REVIEW_ERROR_MESSAGE: 'Sending content back to author(s) failed',
  SOURCE_LABEL: 'Source',
  SOURCE_PLACEHOLDER: 'Definition of source tech stack...',
  STICKY_HEADER_TOOLTIP: 'Check to keep table header visible while scrolling',
  STRATEGY_INSTRUCTION_TEXT:
    'Business perspectives, methodologies, and frameworks for cloud migration and modernization, for CxOs and senior managers.',
  STRATEGY_LABEL: 'Strategies',
  SUBCATEGORIES_PLACEHOLDER: 'Select subcategories',
  SUBCATEGORY_LABEL: 'Subcategory *',
  SUBMIT_BUGS_FEATURE_BUTTON_TEXT: 'Submit',
  SUBMIT_BUGS_FEATURE_SUCCESSFULLY: 'Reported successfully',
  SUBMIT_CONTENT_REQUEST_ERROR: 'Your request could not be submitted. Please try again later.',
  SUBMIT_CONTENT_REQUEST_SUCCESSFULLY: 'Thank you. Your content request has been submitted.',
  SUBMIT_FOR_REVIEW_IN_EDIT_MODE_WARNING: 'Please submit for review in editing mode.',
  SUMMARY_LABEL: 'Summary',
  SYSTEM_LOCK_BANNER:
    'This content is temporarily locked while an automated check is in progress. Some actions are unavailable until this completes.',
  TABLE_CONTENT_SELECTOR_TITLE: 'Select visible columns',
  TABLE_DEFAULT_PAGE_SIZE: 25,
  TABLE_DEFAULT_CONTENT_TYPE: 'Any Type',
  TABLE_DEFAULT_WORKFLOW_STATE: 'Any State',
  TABLE_DEFAULT_WORKFLOW_TAG: 'Any Tag',
  TABLE_MAX_INLINE_FILTERS: 2,
  TABLE_PAGE_SELECTOR_MESSAGE: 'Items per page',
  TABLE_WRAPLINES_DESCRIPTION: 'Check to wrap long text so you can see all of it',
  TABLE_WRAPLINES_LABEL: 'Wrap lines',
  TAGS_ERROR: 'Tags should be separated by commas and must not contain case-insensitive duplicates',
  TAGS_LABEL: 'Tags',
  TAGS_PLACEHOLDER: 'Keywords to search for (e.g., tag1, tag2)',
  TARGET_LABEL: 'Target',
  TARGET_PLACEHOLDER: 'Definition of target technology stack...',
  TASK_DESCRIPTION_LABEL: 'Story description',
  TASK_DESCRIPTION_PLACEHOLDER:
    "Provide additional but brief details about the story. Stories should provide a logical flow of requirements and activities to accomplish the epic.\nProvide enough information to be prescriptive, but don't drill down to details such as UI procedures.",
  TASK_PREDECESSOR_LABEL: 'Select predecessor',
  TASK_PREDECESSOR_PLACEHOLDER: 'This is for any story that must be done prior to this story',
  TASK_REMOVE_CONFIRM_TEXT: 'This operation cannot be undone. Please confirm the delete operation.',
  TASK_SKILLS_CUSTOM_LABEL: 'Custom skills (separate with commas)',
  TASK_SKILLS_CUSTOM_PLACEHOLDER: 'Specify other custom skills',
  TASK_SKILLS_DUPLICATE_SKILL:
    'Custom skills contain duplicates. Select available skills from list.',
  TASK_SKILLS_LABEL: 'Skills required for the story',
  TASK_SKILLS_PLACEHOLDER: 'Specify the expertise or job role required for this story',
  TASK_TITLE_LABEL: 'Story title *',
  TASK_TITLE_PLACEHOLDER: 'Start with a verb; e.g., launch, run, create',
  TASK_TITLE_REQUIRED: 'Story title is required',
  TASK_TITLE_TOO_LONG: 'Maximum story title length is 300 characters',
  TECH_WRITER_ASSIGNMENT_GRAPH_TITLE: 'Contents finalizing by tech writer',
  TECH_WRITER_ASSIGNMENT_GRAPH_EMPTY: 'No Tech writers assigned',
  TECH_WRITER_ASSIGNMENT_TABLE_HEADER: 'Technical writer assignments',
  TECH_WRITER_CONTENTS_HEADER: 'Content to finalize',
  TECH_WRITER_DASHBOARD_BOARD: 'TW dashboard',
  TECH_WRITER_NAV_SECTION_HEADER: 'Tech writer',
  TECHNOLOGIES_LABEL: 'Technologies',
  TECHNOLOGIES_PLACEHOLDER: 'Select all use-case categories that apply to this content',
  TECH_DOMAINS_CONFLICTS_ERROR: 'Additional technologies cannot contain the main technology',
  TECH_WRITER_BREAD_CRUMB: 'Tech writer',
  TECH_WRITER_DASHBOARD_TITLE: 'Tech writer dashboard',
  TECH_WRITER_EXPANDABLE_GRAPH_SECTION_HEADER: 'Graphs',
  TECH_WRITER_FINALIZATION_GRAPH_TITLE: 'Content in finalization',
  TECH_WRITER_FINALIZATION_GRAPH_EMPTY: 'No content in finalization',
  TECH_WRITER_GRAPH_CONTENT_TYPE: 'Any Type',
  TECH_WRITER_NOTES_HEADER: 'Tech writer notes',
  TECH_WRITER_STATE_GRAPH_TITLE: 'All content by state',
  TITLE_LABEL: 'Title *',
  TITLE_PLACEHOLDER_TEXT: 'Enter title here',
  TOOLS_LABEL: 'Tools used',
  TOP1_SEARCH_TERM: 'Oracle',
  TOP2_SEARCH_TERM: 'CloudEndure',
  TOP3_SEARCH_TERM: 'Migration',
  TOP4_SEARCH_TERM: 'SAP',
  TOP5_SEARCH_TERM: 'DB2',
  TROUBLESHOOTING_LABEL: 'Troubleshooting',
  TROUBLESHOOTING_ADD_ISSUE_BUTTON_TEXT: 'Add issue',
  TROUBLESHOOTING_PLACEHOLDER:
    'List any issues that users might encounter when they implement this pattern, and solutions or workarounds.',
  // Un Authorised Page
  UNASSIGN_TECH_WRITER: 'Unassign Tech Writer',
  UNAUTHORISED_HEADER: 'Unauthorised access',
  UNAUTHORISED_NEW_LOGIN_MESSAGE:
    'New user? After initial login, your access rights to the application will be reviewed and approval will be communicated to the registered email.',
  UNPUBLISH_ACTION_MODAL_HEADER: 'Unpublish content',
  UNPUBLISH_BUTTON_TEXT: 'Unpublish',
  UPDATE_APGL_USER_PROFILE_ERROR:
    'Failed to update APGL user profile. Please refresh your screen and try again. If the problem persists, submit an issue from the navigation bar.',
  UPDATE_APGL_USER_PROFILE_INSTRUCTION: 'Are you sure you want to update your user profile?',
  UPDATE_APGL_USER_PROFILE_TEXT: 'Update user profile',
  UPDATE_CONTENT_BUTTON_TEXT: 'Update',
  UPDATE_PROFILE_BUTTON_TEXT: 'Update profile',
  UPDATE_REQUEST_ERROR: 'Error while updating selected requests',
  UPDATE_REQUEST_SUCCESSFULLY: 'Update completed successfully',
  UPDATE_USER_PERMISSION_FORM_HEADER: 'Manage user permissions',
  UPDATE_USER_PERMISSION_SUCCESSFULLY: 'Updated permissions successfully',
  UPLOAD_ATTACHMENT_ERROR: 'Attachment upload failed. Please try again.',
  UPLOAD_ATTACHMENT_FILE_NAME_INVALID:
    'The file name of the file you are trying to upload is invalid. Maximum length is 256 characters, and only numeric, alphanumeric, white spaces and special characters +-._:/. are allowed.',
  UPLOAD_ATTACHMENT_FILE_TOO_LARGE:
    'The file you are trying to upload is too large. Maximum file size is 10 MB.',
  UPLOAD_ATTACHMENT_FILE_TYPE_INVALID:
    'Error: the supported pattern attachment file extensions are: .pptx, .docx and .xlsx',
  UPLOAD_ATTACHMENT_STARTED: 'Uploading attachment...',
  UPLOAD_ATTACHMENT_SUCCESS:
    'Your attachment has been uploaded and is currently being scanned for potential malware.',
  UPLOAD_BUTTON_TEXT: 'Upload new file',
  USER_PERMISSIONS_MANAGEMENT: 'User permissions management',
  USER_PERMISSIONS_NO_USERS: 'No users',
  USER_ROLES_TYPE_ADMIN: 'Admin',
  USER_ROLES_TYPE_PUBLISHER: 'Publisher',
  USER_ROLES_TYPE_REVIEWER: 'Reviewer',
  USER_ROLES_TYPE_TECHWRITER: 'Tech writer',
  USER_ROLES_UPDATE_CONTENT: 'Do you want to save user permissions?',
  USER_ROLES_UPDATE_HEADER: 'Save user permissions',
  USER_ROLES_UPDATE_TEXT: 'Save',
  USER_ROLES_BAR_RAISER: 'Bar Raiser',
  USER_SEARCH_BUTTON_LABEL: 'Search user',
  USER_SEARCH_EMPTY_INFO: 'No users found. (Enter exact full email address)',
  USER_SEARCH_FLASHBAR_MESSAGE: 'Please search for user',
  USER_SEARCH_LABEL: 'User',
  USER_PERMISSION_MGMT_USER_SEARCH_LABEL: 'Search user',
  USER_PERMISSION_MGMT_USER_SEARCH_DESC: 'Search for users by name, e-mail or alias.',
  USER_PERMISSION_MGMT_USER_SEARCH_LOAD_BUTTON_LABEL: 'Load permissions',
  USER_PERMISSION_MGMT_LOADED_INFO: 'Showing permissions for user',
  USER_PERMISSION_MGMT_USER_ROLES_LABEL: 'User Roles',
  USER_PERMISSION_MGMT_USER_ROLES_DESC: 'Select one or more gobal user roles.',
  USER_PERMISSION_MGMT_USER_ROLES_HEADER: 'Global User Roles',
  USER_PERMISSION_MGMT_USER_ROLES_INFO:
    'User roles grant users permission for certain application specific functionalities.',
  USER_PERMISSION_MGMT_CONTENT_USER_ROLES_LABEL: 'Content User Roles',
  USER_PERMISSION_MGMT_CONTENT_USER_ROLES_DESC: 'Select one or more content user roles.',
  USER_PERMISSION_MGMT_CONTENT_USER_ROLES_HEADER: 'Content User Roles',
  USER_PERMISSION_MGMT_CONTENT_USER_ROLES_INFO:
    'Content user roles grant users permission for content specific functionalities.',
  USER_PERMISSION_MGMT_CONTENT_USER_ROLES_ADD_BUTTON_TEXT: 'Add role definition',
  USER_PERMISSION_MGMT_CONTENT_USER_ROLES_ITEM_HEADER: 'Content User Role Definition',
  USER_PERMISSION_MGMT_CONTENT_USER_ROLES_TECH_FILTER_LABEL: 'Technologies Filter',
  USER_PERMISSION_MGMT_CONTENT_USER_ROLES_TECH_FILTER_DESC:
    'Select one or more technologies that the selected content roles should apply to. Technologies are matched against fields "Main Technology" and "Additional Technologies fields in content metadata.',
  USER_SEARCH_PLACEHOLDER: 'Search for user by name or exact full email address, or user ID...',
  User_SEARCH_SEARCHING_INFO: 'Finding users...',
  VALIDATION_SUMMARY_HEADER: 'The following fields have invalid input:',
  VIEW_LABEL: 'View',
  WHAT_WOULD_YOU_LIKE_TO_DO_LABEL: 'What would you like to do?',
  WORKFLOW_DETAILS: 'Activities',
  WORKFLOW_EDIT_HEADER: 'Edit content',
  WORKFLOW_EDIT_IN_REVIEW_ACTIVE_INFO:
    'Content is locked. Please save or discard your changes to re-enable review and publishing tasks.',
  WORKFLOW_EDIT_IN_REVIEW_DISCARD_BUTTON_TEXT: 'Discard all changes',
  WORKFLOW_EDIT_IN_REVIEW_DISCARD_MODAL_TEXT: 'Do you really want to discard all your changes?',
  WORKFLOW_EDIT_IN_REVIEW_EXIT_BUTTON_TEXT: 'Exit edit mode',
  WORKFLOW_EDIT_IN_REVIEW_EXIT_MODAL_TEXT: 'Do you really want to exit edit mode?',
  WORKFLOW_EDIT_INACTIVE_INFO:
    "While you're editing, other users will be able to view your content, but all review and publishing tasks will be disabled. \n\nYou must save or discard your changes to unlock your content.",
  WORKFLOW_EDIT_MODAL_SUBMIT_BUTTON_TEXT: 'Edit content',
  WORKFLOW_EDIT_MODAL_TEXT:
    "Do you really want to edit this content?\n\nWhile you're editing, other users will be able to view your content, but all review and publishing tasks will be disabled. You must save or discard your changes to unlock your content.",
  WORKFLOW_EDIT_SAVE_AND_CLOSE_BUTTON_TEXT: 'Save and close',
  WORKFLOW_EDIT_SAVE_BUTTON_TEXT: 'Save',
  WORKFLOW_EDIT_SAVE_MODAL_TEXT:
    'Do you really want to save your changes and exit edit mode? Your changes will be made available to co-authors.',
  WORKFLOW_EDIT_SAVE_MODAL_HEADER: 'Save and close',
  WORKFLOW_EDIT_PEER_REVIEW_TEXT:
    'Reviewers will continue to review your content, but will be unable to approve until your changes are committed. Do you wish to proceed?',
  WORKFLOW_SAVE_PEER_REVIEW_TEXT:
    'Making changes during a content review will undo any current approvals. Do you want to proceed?',
  WORKFLOW_EDIT_PEER_REVIEW_EXIT_BUTTON_TEXT: 'Save and submit',
  WORKFLOW_WORKING_COPY_PENDING_TEXT: 'Auto-save enabled',
  WORKFLOW_WORKING_COPY_PENDING_TOOLTIP:
    'Changes you make are automatically saved in your browser and on the APG Library server. To make your changes available to other authors or reviewers you have to apply them.',
  WORKFLOW_WORKING_COPY_SUCCESS_TEXT: 'Auto-save enabled',
  WORKFLOW_WORKING_COPY_SUCCESS_TOOLTIP:
    'Your pending changes are saved and will be restored next time you edit this content. To make your changes available to other authors or reviewers you have to apply them.',
  WORKFLOW_WORKING_COPY_LOADING_TEXT: 'Auto-save enabled',
  WORKFLOW_WORKING_COPY_LOADING_TOOLTIP: 'Your pending changes are currently being saved.',
  WORKFLOW_WORKING_COPY_ERROR_TEXT: 'Auto-save error',
  WORKFLOW_WORKING_COPY_ERROR_TOOLTIP:
    'There was an error saving your pending changes. Please make sure you apply your changes before you close the browser window.',
  WORKFLOW_WORKING_COPY_RESTORED_INFO: 'Pending changes restored from auto-saved state.',
  WORKFLOW_DISABLE_SAVE_BUTTON_TOOLTIP_TEXT:
    'Content is unchanged or invalid. Check if all required attributes are filled and valid.',
  WORKFLOW_RANK_PLACEHODER: 'Enter rank value between 1 and 9999',
  WORKFLOW_AUTHOR_FINALIZING_INFO:
    'Publication is currently being finalized by technical writers. You can edit the draft again once the publication has been finalized.',
  WORKFLOW_AUTHOR_FINALIZING_LOADING: 'Loading technical writer changes',
  WORKFLOW_AUTHOR_FINALIZING_CHANGES_PREFIX: 'View changes made by',
  YEARS_OF_EXPERIENCE_EMPTY_ERROR: 'Years of experience cannot be empty',
  WATCH_TUTORIAL: 'Watch tutorial',
  WHATS_NEW: "What's new",
  WHATS_NEW_CARD_DEFAULT_POST_TYPES: 'All Posts',
  MANAGE_POSTS: 'Manage posts',
  BAR_RAISER_DASHBOARD_HEADER: 'Bar Raiser Dashboard',
  SAVE_COLLECTION_BUTTON_TEXT: 'Save collection',
  PUBLISH_COLLECTION_BUTTON_TEXT: 'Publish collection',
  ADD_USER_STORY_BUTTON_TEXT: 'Add user story',
  EDIT_COLLECTION_USER_STORIES_HEADER: 'User stories',
  EDIT_COLLECTION_ATTACHMENT_REPO_TABLE_HEADER: 'Attachments and Repos',
  EDIT_COLLECTION_ATTACHMENT_REPO_TABLE_DESCRIPTION: 'Auto generated based on guidance',
  EDIT_COLLECTION_SEARCH_GUIDANCE_LABEL: 'Choose APGL guidance',
  EDIT_COLLECTION_SEARCH_GUIDANCE_PLACEHOLDER: 'Search by title',
  EDIT_COLLECTION_GUIDANCE_URL_LABEL: 'or add APGL url',
  EDIT_COLLECTION_GUIDANCE_URL_PREFIX: '/content/',
  EDIT_COLLECTION_GUIDANCE_TABLE_HEADER: 'Guidance*',
  EDIT_COLLECTION_GUIDANCE_TABLE_DESCRIPTION: 'One guidance per user story',
  EDIT_COLLECTION_DESCRIPTION_PLACEHOLDER:
    'As a data architect I would like to create an end-to-end data lake architecture so that I understand how our architecture is meeting defined use case requirements.',
  EDIT_COLLECTION_TITLE_TABLE_HEADER: 'User story title*',
  EDIT_COLLECTION_TITLE_PLACEHOLDER: 'Data lake architecture',
  EDIT_COLLECTION_EPIC_DESCRIPTION_PLACEHOLDER: 'Epic description',
  EDIT_COLLECTION_DESCRIPTION_HEADER: 'Description*',
  EDIT_COLLECTION_EPIC_TITLE_PLACEHOLDER: 'Epic title',
  EDIT_COLLECTION_EPIC_KEY: 'epic-key',
  EDIT_COLLECTION_CHAR_LIMIT_TEXT: ' characters remaining',
  EDIT_COLLECTION_CHAR_LIMIT_TEXT_SHORT: ' chars remaining',
  COLLECTION: 'Collection',
  GUIDANCE: 'Guidance',
  CREATE: 'Create',
  ALL_COLLECTIONS: 'All collections',
  ALL_GUIDANCE: 'All guidance',
  COLLECTION_DESCRIPTION:
    'You can group AWS content together to visualize a cloud journey or find cloud journeys created by others.',
  LEARN_ABOUT_COLLECTIONS: 'Learn about Collections',
  COLLECTION_INPUT_CHARACTER_LIMIT_ERROR: 'Must be less than 500 characters.',
  GUIDE_TRAINING_LINK: 'https://broadcast.amazon.com/videos/862206#/',
  //Bar Raiser Quality Questionnaire Page
  FEEDBACK_AND_SCORE_SHARED:
    'All feedback provided as an APG BR and the quality scores will be shared with authors and will help them improve their content quality.',
  PROVIDE_SUMMARIZED_FEEDBACK:
    'Please provide your summarized feedback on this questionnaire for the author.',
  PROVIDE_DETAILED_FEEDBACK:
    'Detailed feedback should be provided as sectional and inline text on the content.',
  CONTACT_US_REPORT_BUG: 'Report a bug',
  CONTACT_US_ADMIN_SUPPORT: 'Get admin support',
  CONTACT_US_FEAT_REQUEST: 'File a feature request',
  CONTACT_US_JOIN_SLACK_CHANNEL: 'Join the Slack channel',
};
